import { useEffect } from 'react'
import { useAppDispatch } from '../../redux/hooks'
import { useAppSelector } from '../../redux/store'
import { fetchTeamMemberPoints } from '../../redux/teamMember/actions'
import {
  selectErrorTeamMemberPoints,
  selectLoadingTeamMemberPoints,
  selectTeamMemberPoints,
} from '../../redux/teamMember/selector'

export function useFetchTeamMemberPoints(queryParams: {
  teamMemberWorkdayId: string
  teamMemberEmail: string
}) {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoadingTeamMemberPoints)
  const error = useAppSelector(selectErrorTeamMemberPoints)
  const teamMemberPoints = useAppSelector(selectTeamMemberPoints)

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchTeamMemberPoints(queryParams)).unwrap()
    }

    fetchData()
  }, [dispatch])

  return { teamMemberPoints, loading, error }
}
